export default __webpack_public_path__ + "static/media/gallery.70e83dcf.svg";